import { z } from 'zod';
import { closedLostReason, funnelStage } from './enums.js';

// PATCH /broker/leads/:id · broker updates a lead's funnel stage / notes.
export const leadUpdateInput = z
  .object({
    funnelStage: funnelStage.optional(),
    notes: z.string().max(4000).optional(),
    closedLostReason: closedLostReason.optional(),
    lastContactedAt: z.coerce.date().optional(),
  })
  .strict();

export type LeadUpdateInput = z.infer<typeof leadUpdateInput>;

// POST /broker/leads/:id/manual-qualify · broker promotes a partial lead to
// fully_qualified with a written justification. Triggers a retroactive
// QualifiedLead CAPI event server-side.
export const manualQualifyLeadInput = z
  .object({
    reason: z.string().trim().min(5).max(500),
  })
  .strict();

export type ManualQualifyLeadInput = z.infer<typeof manualQualifyLeadInput>;
